import { toMap } from '@/utils/objUtil'

export {
  APPEAL_TYPE,
  LEVEL_ONE_APPEAL,
  LEVEL_TWO_APPEAL,
  APPEAL_STATUS,
  APPEAL_TRACK_STATUS,
  MEDIA_TYPE,
  APPEAL_PLAT,
  MATCH_STATUS,

  matchStatusMap,
  appealTypeMap,
  levelOneAppealMap,
  levelTwoAppealMap,
  appealStatusMap,
  appealTrackStatusMap,
  mediaTypeMap,
  appealPlatMap,
  fileExtType,
  rightFileExtType,
  getLevelOneMap,
  getLevelTwoMap,
} from '../const'

const freeze = Object.freeze

export const TASK_TYPE_ENUM = freeze({
  COMPLAINT: 0,
  SONGLIST: 1,
  MATCH: 2,
  CONFIRM: 3
})

export const BUSS_TYPE_ENUM = freeze({
  COMPLAINT: 0,
  OFFLINE: 1,
  WHITELIST: 2
})

export const REVIEW_STATUS_ENUM = freeze({
  DRAFT: 0,
  NOT_AUTH: 1,
  UNREVIEWED: 2,
  REJECT: 3,
  ACCEPTANCE: 4, // 受理中
  DEALING: 5, // 处置中
  FINISHED: 6,
})

export const TRACK_LIST_STATUS_ENUM = freeze({
  UNREVIEWED: 0,
  VALID: 1,
  COMPLAINT_MISTAKE: 2,
  RIGHT_FILE_INVALID: 3,
})

export const PK_STATUS_ENUM = freeze({
  MATCH_NO_RIGHT: 0,
  UNFEEDBACK: 1,
  DISMISSED: 2,
  QUIT: 3,
  COMPLAINT_HOLDING: 4,
  COMPLAINT_REJECT: 5
})

export const taskTypeMap = freeze({
  [TASK_TYPE_ENUM.COMPLAINT]: '申诉工单',
  [TASK_TYPE_ENUM.SONGLIST]: '歌单',
  [TASK_TYPE_ENUM.MATCH]: '匹配结果',
  [TASK_TYPE_ENUM.CONFIRM]: '线上确权'
})

export const bussTypeList = freeze([
  {
    id: BUSS_TYPE_ENUM.COMPLAINT,
    name: '侵权投诉',
  },
  {
    id: BUSS_TYPE_ENUM.OFFLINE,
    name: '下架申请',
  },
  {
    id: BUSS_TYPE_ENUM.WHITELIST,
    name: '白名单',
  },
])
export const bussTypeMap = toMap(bussTypeList)

export const complaintTypeMap = freeze({
  0: '无',
  1: '录音信网',
  2: '盗歌',
  3: '词曲复制',
  4: '词曲信网'
})

export const highTypeMap = freeze({
  0: '无',
  1: '涉诉',
  2: '应用商店/渠道投诉',
  3: '3.0',
  4: '网易屏蔽/独家'
})

export const appealFileLevelMap = freeze({
  0: '未审核',
  1: '通过',
  2: '驳回'
})

export const statusMap = freeze({
  [REVIEW_STATUS_ENUM.DRAFT]: '草稿',
  [REVIEW_STATUS_ENUM.UNREVIEWED]: '待审核',
  [REVIEW_STATUS_ENUM.REJECT]: '未通过',
  [REVIEW_STATUS_ENUM.ACCEPTANCE]: '受理中',
  [REVIEW_STATUS_ENUM.DEALING]: '处置中',
  [REVIEW_STATUS_ENUM.FINISHED]: '已完成'
})

export const appealUserTypeMap = freeze({
  0: '个人',
  1: '公司',
  2: '厂牌',
  3: '用户',
  4: '竞品',
  5: '组织',
  6: '内部自查'
})

export const meidaTypeMap = freeze({
  '-1': '无',
  0: '歌曲',
  1: 'MV',
  2: '有声书单集',
  3: '有声书专辑'
})

export const tracklistStatusMap = freeze({
  [TRACK_LIST_STATUS_ENUM.UNREVIEWED]: '未审核',
  [TRACK_LIST_STATUS_ENUM.VALID]: '有效',
  [TRACK_LIST_STATUS_ENUM.COMPLAINT_MISTAKE]: '投诉有误',
  [TRACK_LIST_STATUS_ENUM.RIGHT_FILE_INVALID]: '权利文件无效',
})

export const pkStatusMap = freeze({
  [PK_STATUS_ENUM.MATCH_NO_RIGHT]: '匹配时无权',
  [PK_STATUS_ENUM.UNFEEDBACK]: '未反馈',
  [PK_STATUS_ENUM.DISMISSED]: '已撤诉',
  [PK_STATUS_ENUM.QUIT]: '放弃',
  [PK_STATUS_ENUM.COMPLAINT_HOLDING]: '申诉挂起',
  [PK_STATUS_ENUM.COMPLAINT_REJECT]: '申诉驳回'
})

export const appealFromMap = freeze({
  0: '无',
  1: '商务',
  2: '法务/公邮',
  3: '涉诉',
  4: '网易'
})

// 计算传入天数的毫秒数
function emitPicker(picker, day) {
  const millisecond = day * 24 * 60 * 60 * 1000
  const date = new Date()
  date.setTime(date.setHours(23, 59, 59, 999) + millisecond)
  picker.$emit('pick', date)
}
export const pickOptions = {
  disabledDate(time) {
    return time.setHours(23, 59, 59, 999) < Date.now()
  },
  shortcuts: [
    {
      text: '1天后',
      onClick(picker) {
        emitPicker(picker, 1)
      }
    },
    {
      text: '2天后',
      onClick(picker) {
        emitPicker(picker, 2)
      }
    },
    {
      text: '3天后',
      onClick(picker) {
        emitPicker(picker, 3)
      }
    },
    {
      text: '5天后',
      onClick(picker) {
        emitPicker(picker, 5)
      }
    },
    {
      text: '10天后',
      onClick(picker) {
        emitPicker(picker, 10)
      }
    },
    {
      text: '20天后',
      onClick(picker) {
        emitPicker(picker, 20)
      }
    },
  ]
}

export const platStatusMap = freeze({
  1: '上架',
  0: '隐藏',
})
